import ReportFoldersService from './report-folders.ts';

/**
 * Predicate for the per-admin dashboard-folders settings row. Folders share the
 * reports subject but live under their own predicate, so a report folder never
 * shows on the Dashboards pages and vice versa.
 */
export const DASHBOARD_FOLDERS_PREDICATE = 'dashboard-folders';

/**
 * Per-admin dashboard folders — the report-folders service pointed at the
 * 'dashboard-folders' predicate. Resolved as `service:dashboard-folders`
 * (tio-reporting's compat-modules glob registers it by filename), a singleton
 * distinct from `report-folders`.
 */
export default class DashboardFoldersService extends ReportFoldersService {
  protected get foldersPredicate() {
    return DASHBOARD_FOLDERS_PREDICATE;
  }

  protected get foldersNoun() {
    return 'dashboard folders';
  }
}
